import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import toast from 'react-hot-toast';

// --- Components & Styles ---
import "../Styles/ProductEdit.css"; // <-- New stylesheet for this page
const API_URL = process.env.REACT_APP_API_URL;
const ProductEdit = () => {
    const { prodcode } = useParams();
    const [form, setForm] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    // BUG FIX: Get the auth token to send with API requests.
    const token = localStorage.getItem("token");
    const headers = useMemo(() => ({ Authorization: `Bearer ${token}` }), [token]);

    useEffect(() => {
        if (!token) {
            navigate("/login");
            return;
        }
        // BUG FIX: Added 'headers' to the GET request to fix the auth error.
        axios.get(`${API_URL}/products/${prodcode}`, { headers })
            .then(res => setForm(res.data))
            .catch((err) => {
                if (err.response?.status === 401) navigate("/login");
                else toast.error("Failed to load product data.");
            })
            .finally(() => setLoading(false));
    }, [prodcode, headers, navigate, token]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                ...form,
                taxpercent: parseFloat(form.taxpercent) || 0,
            };
            // BUG FIX: Added 'headers' to the PUT request.
            await axios.put(`${API_URL}/products/${prodcode}`, payload, { headers });
            toast.success("Product updated successfully!");
            navigate("/masters/products");
        } catch {
            toast.success("Failed to update product.");
        }
    };

    if (loading || !form) {
        return <p style={{ textAlign: "center", padding: "2rem" }}>Loading...</p>;
    }

    return (
        <>
            <div className="form-container">
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="prodname">Product Name</label>
                        <input id="prodname" name="prodname" value={form.prodname} onChange={handleChange} required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="uom">Unit of Measurement (UOM)</label>
                        <input id="uom" name="uom" value={form.uom} onChange={handleChange} required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="hsncode">HSN Code</label>
                        <input id="hsncode" name="hsncode" value={form.hsncode} onChange={handleChange} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="taxpercent">Tax %</label>
                        <input id="taxpercent" name="taxpercent" type="number" step="0.01" value={form.taxpercent} onChange={handleChange} />
                    </div>
                    <div className="form-actions">
                        <button type="button" className="btn btn-outline" onClick={() => navigate(-1)}>Cancel</button>
                        <button type="submit" className="btn btn-primary">Save Changes</button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default ProductEdit;